import { __rest } from '../../_virtual/_tslib.js';
import { EthWalletConnector } from '../EthWalletConnector.js';

class WalletConnect extends EthWalletConnector {
    constructor(_a) {
        var { walletName } = _a, props = __rest(_a, ["walletName"]);
        super(props);
        this.supportedChains = ['EVM', 'ETH'];
        this.connectedChain = 'EVM';
        this.bridge = 'https://bridge.walletconnect.org';
        this.name = walletName;
    }
    getWalletClient() {
        return undefined;
    }
}

export { WalletConnect };
